import React, { useEffect, useState, useContext, useRef } from "react";
import DashboardHeader from "../components/Other/DashboardHeader";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import { useTranslation } from "react-i18next";
import PageContainer from "../components/pages/PageContainer";
import { chatDetails, s3Upload } from "../api/user/index";

import {
  SOCKET_EV_JOIN,
  SOCKET_EV_RECEIVE_MESSAGE,
  SOCKET_EV_SEND_MESSAGE,
  socket as chatSocket,
  SocketContext,
} from "../utils/socketio";
import Loader from "../components/Loader";
import { useOutletContext, useParams } from "react-router-dom";
import moment from "moment-timezone";
import { toast } from "react-toastify";
import { PreviewImage } from "./previewImage";
import { PreviewVideo } from "./previewVideo";
import { event } from "../utils/event";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import GameSideBar from "../components/Games/GameSideBar";

const generateToken = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let token = "";
  for (let i = 0; i < 14; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    token += characters.charAt(randomIndex);
  }
  return token;
};

const ChatHistoryPage = (props) => {
  const game_id = props.game_id ?? null;
  const slug = props.slug ?? null;
  const { t } = useTranslation();
  const { chatid, chatgid } = useParams();
  const socket = useContext(SocketContext);
  const token = JSON.parse(localStorage.getItem("accessToken"));
  const gid = chatgid ? chatgid : localStorage.getItem("gid");
  const id = chatid ? chatid : localStorage.getItem("id");
  const user = JSON.parse(localStorage.getItem("userInfo"));
  const user_id = JSON.parse(user?.id);
  const [isPreview, setIsPreview] = useState(false);
  const [isPreviewVideo, setIsPreviewVideo] = useState(false);
  const [attachments, setAttachments] = useState("");
  const [chat, setChat] = useState([]);
  const [messageInput, setMessageInput] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isDataFeteched, setisDataFeteched] = useState(false);
  const avta = localStorage.getItem("image");
  const chatContainerRef = useRef(null);
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const flutter = localStorage.getItem("isFlutterInAppWebViewReady");
  const deviceToken = localStorage.getItem("DeviceToken") || generateToken();
  const [deviceT, setDeviceT] = useState(deviceToken);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(null);

  const [showVideos, setShowVideos] = useState(
    new Array(chat?.length).fill(false)
  );

  const handleVideoClick = (index) => {
    setShowVideos((prev) => ({
      ...prev,
      [index]: !prev[index], // Toggle the state
    }));

    Object.keys(videoRefs.current).forEach((key) => {
      if (parseInt(key) !== index && videoRefs.current[key]) {
        videoRefs.current[key].pause();
        setShowVideos((prev) => ({
          ...prev,
          [key]: false, // Ensure other videos are set to false (paused)
        }));
      }
    });

    const videoRef = videoRefs.current[index];
    if (videoRef) {
      if (showVideos[index]) {
        videoRef.pause();
      } else {
        videoRef.play().catch((error) => {
          console.error("Error playing video:", error);
        });
      }
    }
  };

  const videoRefs = useRef([]);

  const getVideoThumbnail = (videoUrl) => {
    const video1 = videoUrl + ".jpg";
    return video1;
  };

  const getDeviceAndBrowserInfo = () => {
    const userAgent = navigator.userAgent;
    let device_type = "Unknown";
    let device_name = "Unknown";

    if (userAgent.includes("Windows")) {
      device_type = "W";
    } else if (userAgent.includes("Macintosh")) {
      device_type = "W";
    } else if (userAgent.includes("Linux")) {
      device_type = "W";
    } else if (userAgent.includes("Safari")) {
      device_type = "W";
    }
    if (userAgent.includes("Chrome")) {
      device_name = "Chrome";
    } else if (userAgent.includes("Safari")) {
      device_name = "Safari";
    } else if (userAgent.includes("Firefox")) {
      device_name = "Firefox";
    } else if (userAgent.includes("Edge")) {
      device_name = "Edge";
    } else if (userAgent.includes("Opera")) {
      device_name = "Opera";
    }
    if (/Android/i.test(userAgent)) {
      device_type = "A";
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      device_type = "I";
    } else {
      device_type = "W";
    }
    return { device_type, device_name };
  };

  const fetchChatList = async () => {
    setIsLoading(true);
    let dataObj = {};
    if (id) {
      dataObj = {
        receiver_id: id,
      };
    } else {
      dataObj = {
        chat_group_id: gid,
      };
    }

      // Include game_id if it's set
  if (game_id) {
    dataObj.game_id = game_id;
  }

    try {
      const response = await chatDetails(dataObj);
      if (response) {
        setisDataFeteched(true);
        const sortedChats = response?.data?.data?.data.sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );
        setChat(sortedChats);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const FCMToken =
    localStorage.getItem("FCM-WEB") || localStorage.getItem("FCM");
  useEffect(() => {
    if (socket) {
      socket.on("connect", () => {
        console.log("Socket connected");
        joinChat();
      });

      socket.on("disconnect", () => {
        console.log("Socket disconnected");
      });

      socket.on(SOCKET_EV_RECEIVE_MESSAGE, (receivedMessage) => {
        console.log("Received Message:", receivedMessage);
        // setChat((prevChat) => [...prevChat, receivedMessage]);
      });

      if (!isDataFeteched) fetchChatList();

      return () => {
        socket.off(SOCKET_EV_RECEIVE_MESSAGE);
      };
    }
  }, [socket, id, gid, isDataFeteched]);
  const joinChat = () => {
    let dataObjJoinChat = {};

    if (id !== null && id !== undefined) {
      dataObjJoinChat = {
        type: "1",
        receiver_id: id,
      };
    } else {
      dataObjJoinChat = {
        type: "1",
        chat_group_id: gid,
      };
    }

    const joinChatRequest = {
      method: "post",
      route: "join-chat",
      param: dataObjJoinChat,
      headers: {
        Authorization: `Bearer ${token}`,
        "Accept-Language": "en",
        "Device-name":
          localStorage.getItem("DeviceName") ||
          getDeviceAndBrowserInfo().device_name,
        "Device-Type":
          localStorage.getItem("DeviceType") ||
          getDeviceAndBrowserInfo().device_type,
        "Device-Token":
          deviceT || localStorage.getItem("DeviceToken") || generateToken,
        "FCM-Token":
          FCMToken ||
          localStorage.getItem("FCM-WEB") ||
          localStorage.getItem("FCM"),
        "App-Version": "1.2",
        Timezone: timezone,
      },
    };

    socket.emit(SOCKET_EV_JOIN, joinChatRequest, (acknowledgment) => {
      console.log("Acknowledgment from server for join:", acknowledgment);
      if (acknowledgment.status === 400) {
        console.log("Rejoining due to status 400");
        setTimeout(joinChat, 3000);
      }
    });
  };

  useEffect(() => {
    if (socket) {
      socket.on(SOCKET_EV_RECEIVE_MESSAGE, (receivedMessage) => {
        // console.log("Received Message:", receivedMessage);
        setChat((prevChat) => [...prevChat, receivedMessage]);
      });

      if (!isDataFeteched) fetchChatList();

      return () => {
        socket.off(SOCKET_EV_RECEIVE_MESSAGE);
      };
    }
  }, [socket, id, gid, isDataFeteched]);

  const [images, setImages] = useState([]);
  const [imgUrls, setImgUrls] = useState([]);
  const userinfo = JSON.parse(localStorage.getItem("userInfo"));

  useEffect(() => {
    const handleCustomProfileEvent = async (event) => {
      if (event?.detail?.imageChat) {
        const baseUrl = userinfo?.s3_url;
        setImages({ src: baseUrl + event?.detail?.imageChat });
        setImgUrls({ src: baseUrl + event?.detail?.imageChat });
        const data1 =
          event?.detail?.imageChat.length > 0
            ? event?.detail?.imageChat[0]
            : event?.detail?.imageChat;
        await sendMessage(event, data1);
      }
    };

    window.addEventListener("myCustomChatEvent", handleCustomProfileEvent);
    return () => {
      window.removeEventListener("myCustomChatEvent", handleCustomProfileEvent);
    };
  }, [user, window.addEventListener]);

  const handleImageUpload = async (e) => {
    const selectedFiles = e.target.files;
    const allowedExtensionsRegex = /\.(jpg|jpeg|png|svg|mp4|mov|avi|wmv)$/i;
    console.log(selectedFiles, "selectedFiles");
    const fileName = selectedFiles[0].name;
    const fileSize = selectedFiles[0].size;
    const maxSize = 512 * 1024 * 1024;

    if (!allowedExtensionsRegex.test(fileName)) {
      toast.error("You can only select either an image or a video!");
      return;
    } else if (fileSize > maxSize) {
      toast.error("File size should not be greater that 512 Mb!");
      return;
    }
    let newImages = [];
    // const newImages = Array.from(selectedFiles)
    //   .slice(0, 5 - images.length)
    //   .map((file) => ({
    //     id: null,
    //     image: null,
    //     blob: file,
    //     preview: URL.createObjectURL(file),
    //   }));
    const obj = {
      id: null,
      image: null,
      blob: selectedFiles[0],
      preview: URL.createObjectURL(selectedFiles[0]),
    };
    newImages.push(obj);
    console.log(obj, "newImages");

    try {
      setIsLoading(true);
      const response = await s3Upload(newImages);
      if (response && response.data && response.data.data) {
        const imageArray = response.data.data.map((path) => path);
        const imageJsonString = JSON.stringify(imageArray);
        setImgUrls(imageJsonString);
        console.log(imageJsonString, "imageJsonString");
        if (imageArray[0]) sendMessage(e, imageArray[0]);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const sendMessage = (e, imageJsonString) => {
    e.preventDefault();
    console.log(imageJsonString, "imageJsonString-1");
    goToTop();
    const videoExtensionsRegex = /\.(mp4|mov|avi|wmv)$/i;

    if (!messageInput.trim() && !imageJsonString) {
      return;
    } else if (!messageInput.trim() && imageJsonString) {
      console.log(imageJsonString, "imageJsonString-2");

      setIsDisabled(true);
      let dataObj = {};
      if (id) {
        if (imageJsonString.length > 0) {
          console.log(imageJsonString, "imageJsonString-3");
          dataObj = {
            type: videoExtensionsRegex.test(imageJsonString) ? 3 : 2,
            receiver_id: id,
            message: "",
            attachments: imageJsonString,
          };
          console.log(imageJsonString, "imageJsonString-4", dataObj);
        } else {
          dataObj = {
            type: 1,
            receiver_id: id,
            message: messageInput,
          };
        }
      } else {
        if (imageJsonString.length > 0) {
          console.log(imageJsonString, "imageJsonString-5");
          dataObj = {
            type: videoExtensionsRegex.test(imageJsonString) ? 3 : 2,
            chat_group_id: gid,
            message: "",
            attachments: imageJsonString,
          };
          console.log(imageJsonString, "imageJsonString-6", dataObj);
        } else {
          dataObj = {
            type: 1,
            chat_group_id: gid,
            message: messageInput,
          };
        }
      }
      console.log(imageJsonString, "imageJsonString-7", dataObj);
        // Add `game_id` if it is available
        if (game_id) {
          dataObj.game_id = game_id;
        }
      const messageRequest = {
        method: "post",
        route: "send-message",
        param: dataObj,
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": "en",
          "Device-name":
            localStorage.getItem("DeviceName") ||
            getDeviceAndBrowserInfo().device_name,
          "Device-Type":
            localStorage.getItem("DeviceType") ||
            getDeviceAndBrowserInfo().device_type,
          "Device-Token":
            deviceT || localStorage.getItem("DeviceToken") || generateToken(),
          "FCM-Token":
            FCMToken ||
            localStorage.getItem("FCM-WEB") ||
            localStorage.getItem("FCM"),
          "App-Version": "1.2",
          Timezone: timezone,
        },
      };
      console.log(messageRequest, "imageJsonString-8-final");

      socket.emit(SOCKET_EV_SEND_MESSAGE, messageRequest, (acknowledgment) => {
        goToTop();
        console.log(acknowledgment, "imageJsonString-9-acknowledgment");
        if (acknowledgment) {
          setChat((prevChat) => [...prevChat, acknowledgment]);
          setMessageInput("");
          setIsDisabled(false);
        } else {
          setIsDisabled(false);
          console.error("Error sending message:", acknowledgment.message);
        }
      });
    } else {
      setIsDisabled(true);
      let dataObj = {};
      if (id) {
        if (imageJsonString.length > 0) {
          dataObj = {
            type: videoExtensionsRegex.test(imageJsonString) ? 3 : 2,
            receiver_id: id,
            message: "",
            attachments: imageJsonString,
          };
        } else {
          dataObj = {
            type: 1,
            receiver_id: id,
            message: messageInput,
          };
        }
      } else {
        if (imageJsonString.length > 0) {
          dataObj = {
            type: videoExtensionsRegex.test(imageJsonString) ? 3 : 2,
            chat_group_id: gid,
            message: "",
            attachments: imageJsonString,
          };
        } else {
          dataObj = {
            type: 1,
            chat_group_id: gid,
            message: messageInput,
          };
        }
      }
        // Add `game_id` if it is available
      if (game_id) {
        dataObj.game_id = game_id;
      }

      const messageRequest = {
        method: "post",
        route: "send-message",
        param: dataObj,
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": "en",
          "Device-name":
            localStorage.getItem("DeviceName") ||
            getDeviceAndBrowserInfo().device_name,
          "Device-Type":
            localStorage.getItem("DeviceType") ||
            getDeviceAndBrowserInfo().device_type,
          "Device-Token":
            deviceT || localStorage.getItem("DeviceToken") || generateToken(),
          "FCM-Token":
            FCMToken ||
            localStorage.getItem("FCM-WEB") ||
            localStorage.getItem("FCM"),
          "App-Version": "1.2",
          Timezone: timezone,
        },
      };
      socket.emit(SOCKET_EV_SEND_MESSAGE, messageRequest, (acknowledgment) => {
        console.log(acknowledgment, "message-9-acknowledgment");
        if (acknowledgment) {
          setChat((prevChat) => [...prevChat, acknowledgment]);
          setMessageInput("");
          setIsDisabled(false);
        } else {
          setIsDisabled(false);
          console.error("Error sending message:", acknowledgment.message);
        }
      });
    }
    // setIsDisabled(false);
  };

  // const sendMessage = (e, imageJsonString) => {
  //   e.preventDefault();
  //   console.log(imageJsonString, "imageJsonString-1");
  //   goToTop();
  //   const videoExtensionsRegex = /\.(mp4|mov|avi|wmv)$/i;

  //   if (!messageInput && !imageJsonString) {
  //     return;
  //   } else if (!messageInput && imageJsonString) {
  //     console.log(imageJsonString, "imageJsonString-2");

  //     setIsDisabled(true);
  //     let dataObj = {};
  //     if (id) {
  //       if (imageJsonString.length > 0) {
  //         console.log(imageJsonString, "imageJsonString-3");
  //         dataObj = {
  //           type: videoExtensionsRegex.test(imageJsonString) ? 3 : 2,
  //           receiver_id: id,
  //           message: "",
  //           attachments: imageJsonString,
  //         };
  //         console.log(imageJsonString, "imageJsonString-4", dataObj);
  //       } else {
  //         dataObj = {
  //           type: 1,
  //           receiver_id: id,
  //           message: messageInput,
  //         };
  //       }
  //     } else {
  //       if (imageJsonString.length > 0) {
  //         console.log(imageJsonString, "imageJsonString-5");
  //         dataObj = {
  //           type: videoExtensionsRegex.test(imageJsonString) ? 3 : 2,
  //           chat_group_id: gid,
  //           message: "",
  //           attachments: imageJsonString,
  //         };
  //         console.log(imageJsonString, "imageJsonString-6", dataObj);
  //       } else {
  //         dataObj = {
  //           type: 1,
  //           chat_group_id: gid,
  //           message: messageInput,
  //         };
  //       }
  //     }
  //     console.log(imageJsonString, "imageJsonString-7", dataObj);
  //     const messageRequest = {
  //       method: "post",
  //       route: "send-message",
  //       param: dataObj,
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Accept-Language": "en",
  //         "Device-name":
  //           localStorage.getItem("DeviceName") ||
  //           getDeviceAndBrowserInfo().device_name,
  //         "Device-Type":
  //           localStorage.getItem("DeviceType") ||
  //           getDeviceAndBrowserInfo().device_type,
  //         "Device-Token":
  //           localStorage.getItem("DeviceToken") || generateToken(),
  //         "FCM-Token":
  //           FCMToken ||
  //           localStorage.getItem("FCM-WEB") ||
  //           localStorage.getItem("FCM"),
  //         "App-Version": "1.2",
  //         Timezone: timezone,
  //       },
  //     };
  //     console.log(messageRequest, "imageJsonString-8-final");

  //     socket.emit(SOCKET_EV_SEND_MESSAGE, messageRequest, (acknowledgment) => {
  //       scrollToBottom();
  //       console.log(acknowledgment, "imageJsonString-9-acknowledgment");
  //       if (acknowledgment) {
  //         setChat((prevChat) => [...prevChat, acknowledgment]);
  //         setMessageInput("");
  //         setIsDisabled(false);
  //       } else {
  //         setIsDisabled(false);
  //         console.error("Error sending message:", acknowledgment.message);
  //       }
  //     });
  //   } else {
  //     setIsDisabled(true);
  //     let dataObj = {};
  //     if (id) {
  //       if (imageJsonString.length > 0) {
  //         dataObj = {
  //           type: videoExtensionsRegex.test(imageJsonString) ? 3 : 2,
  //           receiver_id: id,
  //           message: "",
  //           attachments: imageJsonString,
  //         };
  //       } else {
  //         dataObj = {
  //           type: 1,
  //           receiver_id: id,
  //           message: messageInput,
  //         };
  //       }
  //     } else {
  //       if (imageJsonString.length > 0) {
  //         dataObj = {
  //           type: videoExtensionsRegex.test(imageJsonString) ? 3 : 2,
  //           chat_group_id: gid,
  //           message: "",
  //           attachments: imageJsonString,
  //         };
  //       } else {
  //         dataObj = {
  //           type: 1,
  //           chat_group_id: gid,
  //           message: messageInput,
  //         };
  //       }
  //     }
  //     const messageRequest = {
  //       method: "post",
  //       route: "send-message",
  //       param: dataObj,
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Accept-Language": "en",
  //         "Device-name":
  //           localStorage.getItem("DeviceName") ||
  //           getDeviceAndBrowserInfo().device_name,
  //         "Device-Type":
  //           localStorage.getItem("DeviceType") ||
  //           getDeviceAndBrowserInfo().device_type,
  //         "Device-Token":
  //           localStorage.getItem("DeviceToken") || generateToken(),
  //         "FCM-Token":
  //           FCMToken ||
  //           localStorage.getItem("FCM-WEB") ||
  //           localStorage.getItem("FCM"),
  //         "App-Version": "1.2",
  //         Timezone: timezone,
  //       },
  //     };

  //     socket.emit(SOCKET_EV_SEND_MESSAGE, messageRequest, (acknowledgment) => {
  //       if (acknowledgment) {
  //         setChat((prevChat) => [...prevChat, acknowledgment]);
  //         setMessageInput("");
  //         setIsDisabled(false);
  //       } else {
  //         setIsDisabled(false);

  //         console.error("Error sending message:", acknowledgment.message);
  //       }
  //     });
  //   }
  //   // setIsDisabled(false);
  // };
  function calculateTimeAgo(created_at) {
    const currentDate = new Date();
    const createdAtDate = new Date(created_at);

    const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    const day = days[createdAtDate.getDay()];

    let hours = createdAtDate.getHours();
    const minutes = String(createdAtDate.getMinutes()).padStart(2, "0");

    // Determine AM/PM
    const ampm = hours >= 12 ? "PM" : "AM";

    // Convert to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 should be converted to 12

    const timeDifference = Math.max(
      0,
      currentDate.getTime() - createdAtDate.getTime()
    );

    const secondsInMs = 1000;
    const minutesInMs = secondsInMs * 60;
    const hoursInMs = minutesInMs * 60;

    // Check if createdAtDate is today
    const isToday =
      currentDate.getDate() === createdAtDate.getDate() &&
      currentDate.getMonth() === createdAtDate.getMonth() &&
      currentDate.getFullYear() === createdAtDate.getFullYear();

    if (isToday) {
      return `${hours}:${minutes} ${ampm}`;
    } else if (timeDifference < hoursInMs) {
      return "Today";
    } else {
      // const month = String(createdAtDate.getMonth() + 1).padStart(2, "0");
      // const year = createdAtDate.getFullYear();
      return `${day} ${hours}:${minutes} ${ampm} `;
    }
  }

  const handleInputChange = (event) => {
    setMessageInput(event.target.value);
  };

  const isTodayOrYesterday = (date) => {
    const currentDate = new Date();
    const messageDate = new Date(date);

    const currentDateString = currentDate.toLocaleDateString();
    const messageDateString = messageDate.toLocaleDateString();

    if (currentDateString === messageDateString) {
      return "Today";
    } else {
      const yesterday = new Date(currentDate);
      yesterday.setDate(currentDate.getDate() - 1);
      if (yesterday.toLocaleDateString() === messageDateString) {
        return "Yesterday";
      } else {
        // Handle other days as needed
        return messageDate.toLocaleDateString();
      }
    }
  };

  const groupMessagesByDate = () => {
    return chat && chat.length > 0
      ? chat.reduce((result, message) => {
          // const messageDate = new Date(message.created_at).toLocaleDateString();
          const section = isTodayOrYesterday(message.created_at);

          if (!result[section]) {
            result[section] = [];
          }
          result[section].push(message);
          return result;
        }, {})
      : "";
  };

  const [sidebarToggle] = useOutletContext();

  const isMobileView = document.body.clientWidth <= 768;

  const bottomRef = useRef();

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chat]);

  const goToTop = () => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleCloseClick = () => {
    setIsPreview(false);
    setAttachments("");
  };

  const handleCloseVideoClick = () => {
    setIsPreviewVideo(false);
    setAttachments("");
  };

  return (
    <div className="overflow-hidden">
      <DashboardHeader toggle={sidebarToggle} />
      <PageHeaderTitle title={t("Chat")} />

      <div className="flex items-center bg-white justify-center py-3 border-gray-200 px-4 md:px-0">
        <div className="flex md:ml-48 ml-0 items-center justify-center space-x-4 relative">
          <img
            src={avta}
            alt=""
            className="w-12 h-12 rounded-full relative object-cover"
          />
          <span className="absolute bottom-0 right-0 bg-green-500 h-4 w-4 border-2 border-white rounded-full"></span>
        </div>
      </div>
      <PageContainer gamePage={game_id && true} className="">
      {game_id && <GameSideBar activeMenu="" slug={slug} />}
        {isLoading ? (
          <Loader />
        ) : (
          <div className="md:block  rounded-2xl bg-white max-w-[60rem] mx-auto">
            <div className="flex flex-col">
              <div
                className={
                  isMobileView
                    ? "flex-1 bg-white  overflow-y-auto mb-36"
                    : "flex-1 bg-white  overflow-y-auto mb-20"
                }
              >
                {Object.entries(groupMessagesByDate()).map(
                  ([section, messages], index) => (
                    <div key={index} className="chat-message">
                      {console.log(section, "section")}
                      <span className="text-[#707070] mb-6 flex justify-center md:mr-[3rem] mr-[20px] -mb-4 md:ml-0 mt-4 ml-[1.5rem]">

                        {section === "Today"
                          ? "Today"
                          : section === "Yesterday"
                          ? "Yesterday"
                          : section}
                      </span>

                      {messages.map((message, i) => {
                        const index = i; // Assuming index corresponds to message index

                        return (
                          <div
                            key={i}
                            className={`flex items-end md:ml-8 ml-2 ${
                              message.user_id === user_id
                                ? "justify-end"
                                : "justify-start"
                            }`}
                          >
                            {message.user_id !== user_id && (
                              <img
                                src={message.user?.image}
                                alt="Profile"
                                className="w-[34px] h-[34px] object-cover rounded-full mb-6 mr-2"
                              />
                            )}
                            <div className="flex flex-col space-y-2 text-xs max-w-xs mx-2 order-1">
                              <div>
                                {message.attachments ? (
                                  <>
                                    {message.type === "3" ? (
                                      <div
                                        className={
                                          isMobileView
                                            ? "w-[200px] h-[100px] relative rounded-lg"
                                            : "w-[300px] h-[200px] relative rounded-lg"
                                        }
                                      >
                                        {!showVideos[index] ? (
                                          <img
                                            src={getVideoThumbnail(
                                              message.attachments
                                            )}
                                            id={`image-${index}`}
                                            className={
                                              isMobileView
                                                ? "w-[200px] h-[100px] object-cover rounded-lg"
                                                : "w-[400px] h-[200px] object-cover rounded-lg"
                                            }
                                            alt="Video Thumbnail"
                                            onClick={() => {
                                              handleVideoClick(index);
                                            }}
                                          />
                                        ) : (
                                          <video
                                            ref={(el) =>
                                              (videoRefs.current[index] = el)
                                            }
                                            autobuffer
                                            controls
                                            autoPlay
                                            playsInline={true}
                                            webkit-playsinline="true"
                                            x5-playsinline="true"
                                            x-webkit-airplay="deny"
                                            disablePictureInPicture={true}
                                            controlsList="nodownload"
                                            onContextMenu={(e) =>
                                              e.preventDefault()
                                            }
                                            id={`video-${index}`}
                                            preload="auto"
                                            className="w-full h-full object-cover rounded-lg"
                                            onLoadedMetadata={(e) => {
                                              if (isMobileView) {
                                                e.target.currentTime = 1;
                                              }
                                            }}
                                          >
                                            <source src={message.attachments} />
                                          </video>
                                        )}
                                        <button
                                          id={`play-button-${index}`}
                                          className="absolute inset-0 flex rounded-lg items-center justify-center bg-black bg-opacity-50 text-white"
                                          style={{
                                            display: showVideos[index]
                                              ? "none"
                                              : "block",
                                          }}
                                          onClick={() => {
                                            handleVideoClick(index);
                                          }}
                                        >
                                          <FontAwesomeIcon
                                            className="h-7"
                                            icon={faPlay}
                                          />
                                        </button>
                                      </div>
                                    ) : (
                                      <img
                                        src={message.attachments}
                                        alt="Profile"
                                        className={
                                          isMobileView
                                            ? "w-[200px] h-[100px] object-cover rounded-lg"
                                            : "w-[400px] h-[300px] object-cover rounded-lg"
                                        }
                                        onClick={() => {
                                          setIsPreview(true);
                                          setAttachments(message.attachments);
                                        }}
                                      />
                                    )}
                                  </>
                                ) : (
                                  ""
                                )}
                                <div className="w-51 h-auto mb-4">
                                  {message.message && (
                                    <span
                                      className={`px-4 py-2 w-full h-auto break-words rounded-lg inline-block ${
                                        message.user_id === user_id
                                          ? "rounded-br-none bg-primaryColor text-white"
                                          : "rounded-bl-none bg-gray-300 text-gray-600"
                                      }`}
                                    >
                                      {message.message}
                                    </span>
                                  )}
                                  <div
                                    className={`text-gray-500 text-sm ${
                                      message.user_id === user_id
                                        ? "flex justify-end"
                                        : "flex justify-start"
                                    }`}
                                  >
                                    <p>
                                      {calculateTimeAgo(message.created_at)}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div ref={bottomRef} />
                          </div>
                        );
                      })}
                    </div>
                  )
                )}
              </div>
              <div className="flex-none ">
                <form
                  className="px-2 py-2 bg-white border-t-2 fixed  right-0 bottom-0 w-full"
                  onSubmit={(e) => sendMessage(e, "")}
                >
                  <div className="relative flex md:mb-0 mb-20 sm:mb-20">
                    <span
                      style={{
                        marginLeft: isMobileView ? "" : "250px",
                      }}
                      className="absolute inset-y-0 flex items-center"
                    >
                      {flutter ? (
                        <div
                          className={
                            isMobileView
                              ? "md:w-1/3 p-4"
                              : "md:w-1/3 p-4 border-r"
                          }
                        >
                          <label
                            htmlFor="upload"
                            onClick={() => event("imageUploadChat")}
                            className="block text-center py-3 rounded-xl  cursor-pointer"
                          >
                            {/* <input
                              type="file"
                              id="upload"
                              accept="image/*"
                              multiple
                              onChange={handleImageUpload}
                              className="hidden"
                              disabled={true}
                            /> */}
                            {/* <label
                              htmlFor="imageInput"
                              className="inline-flex items-center justify-center rounded-full h-10 w-10 transition duration-500 ease-in-out text-gray-500 hover:bg-gray-300 focus:outline-none"
                            > */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              className="h-6 w-6 text-gray-600"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                              ></path>
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                              ></path>
                            </svg>
                          </label>
                          {/* </label> */}
                        </div>
                      ) : (
                        <div>
                          <input
                            type="file"
                            accept="image/*,video/*"
                            multiple={false}
                            onChange={handleImageUpload}
                            className="hidden"
                            id="imageInput"
                          />
                          <label
                            htmlFor="imageInput"
                            className="inline-flex items-center justify-center rounded-full h-10 w-10 transition duration-500 ease-in-out text-gray-500 hover:bg-gray-300 focus:outline-none"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              className="h-6 w-6 text-gray-600"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                              ></path>
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                              ></path>
                            </svg>
                          </label>
                        </div>
                      )}
                    </span>
                    <input
                      type="text"
                      placeholder="Type something here"
                      style={{
                        marginLeft: isMobileView ? "" : "250px",
                      }}
                      value={messageInput}
                      onChange={handleInputChange}
                      className={
                        !messageInput
                          ? "w-full break-words  focus:outline-none focus:placeholder-gray-400 text-gray-600 placeholder-gray-600 pl-12 bg-[#FBFCFC] border-red rounded-md py-3"
                          : "w-full break-words  focus:outline-none focus:placeholder-gray-400 text-gray-600 placeholder-gray-600 pl-12 bg-[#FBFCFC] border-white-500 rounded-md py-3"
                      }
                    />
                    <div className="absolute top-0 right-0 flex items-center mt-2">
                      <div className="sm:hidden">
                        <button
                          type="submit"
                          disabled={isDisabled ? true : false}
                          className="inline-flex items-center justify-center rounded-full h-10 w-10 transition duration-500 ease-in-out text-gray-500 hover:bg-gray-300 focus:outline-none"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="gray"
                            className="h-6 w-6 ml-2 transform rotate-90"
                          >
                            <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"></path>
                          </svg>
                        </button>
                      </div>
                      <div className="hidden sm:flex">
                        <div className="absolute right-0 mt-4 items-center inset-y-0 hidden sm:flex">
                          <div>
                            {flutter ? (
                              <div
                                className={
                                  isMobileView
                                    ? "md:w-1/3 p-4"
                                    : "md:w-1/3 p-4 border-r"
                                }
                              >
                                <label
                                  htmlFor="upload"
                                  onClick={() => event("imageUploadChat")}
                                  className="block text-center py-3 rounded-xl  cursor-pointer"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    className="h-6 w-6 text-gray-600"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                                    ></path>
                                  </svg>
                                </label>
                              </div>
                            ) : (
                              <div>
                                <input
                                  type="file"
                                  accept="image/*,video/*"
                                  multiple={false}
                                  onChange={handleImageUpload}
                                  className="hidden"
                                  id="imageInput"
                                />
                                <label
                                  htmlFor="imageInput"
                                  className="inline-flex items-center justify-center rounded-full h-10 w-10 transition duration-500 ease-in-out text-gray-500 hover:bg-gray-300 focus:outline-none"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    className="h-6 w-6 text-gray-600"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                                    ></path>
                                  </svg>
                                </label>
                              </div>
                            )}
                          </div>
                          <button
                            disabled={isDisabled ? true : false}
                            type="submit"
                            className="inline-flex items-center justify-center rounded-full px-3 py-2 transition duration-500 ease-in-out text-white hover:bg-gray-400 focus:outline-none"
                          >
                            <span className="font-bold"></span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="gray"
                              className="h-6 w-6 ml-2 transform rotate-90"
                            >
                              <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"></path>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
        {isPreview && (
          <PreviewImage src={attachments} onClick={handleCloseClick} />
        )}
        {isPreviewVideo && (
          <PreviewVideo src={attachments} onClick={handleCloseVideoClick} />
        )}
      </PageContainer>
    </div>
  );
};

export default ChatHistoryPage;
